import React from "react";
import { TextField } from "@material-ui/core";

interface Props {
  label: string;
  type?: string;
  value: any;
  onChange?: any;
  helperText?: any;
  error?: boolean;
  required?: boolean;
  name?: string;
  isReadOnly?: boolean;
  maxDate?: string;
  minDate?: string;
  onBlur?: any;
}

const CommonTextFieldDate = ({
  label,
  type = "",
  value,
  onChange,
  helperText = "",
  error = false,
  required = false,
  name = "",
  isReadOnly = false,
  maxDate = "",
  minDate = "",
  onBlur,
}: Props) => {
  return (
    <TextField
      disabled={isReadOnly}
      id={name}
      name={name}
      label={label}
      required={required}
      type={type}
      value={value}
      onChange={(e) => {
        if (maxDate || minDate) {
          if (maxDate && maxDate >= e.target.value) {
            if (minDate) {
              if (minDate <= e.target.value) {
                onChange(e);
              }
            } else {
              onChange(e);
            }
          }
          if (minDate && minDate <= e.target.value) {
            if (maxDate) {
              if (maxDate >= e.target.value) {
                onChange(e);
              }
            } else {
              onChange(e);
            }
          }
        } else {
          onChange(e);
        }
      }}
      onBlur={onBlur}
      helperText={helperText}
      error={error}
      variant="outlined"
      size="small"
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        inputProps: { max: maxDate || "", min: minDate || "" },
      }}
      fullWidth
    />
  );
};

export default CommonTextFieldDate;
